/**
 * @namespace Languages
 */
import * as Arabic from './ar-ar';
import * as Catalan from './ca-es';
import * as Czech from './cs-cz';
import * as Danish from './da-dk';
import * as German from './de-de';
import * as English from './en-us';
import * as Spanish from './es-es';
import * as Persian from './fa-ir';
import * as Finnish from './fi-fi';
import * as French from './fr-ca';
import * as Hebrew from './he-il';
import * as Hungarian from './hu-hu';
import * as Italian from './it-it';
import * as Japanese from './ja-jp';
import * as Korean from './ko-kr';
import * as Latvian from './lv-lv';
import * as Dutch from './nl-be';
import * as Norwegian from './no-nb';
import * as Polish from './pl-pl';
import * as Portuguese from './pt-br';
import * as Romanian from './ro-ro';
import * as Russian from './ru-ru';
import * as Slovak from './sk-sk';
import * as Swedish from './sv-se';
import * as Thai from './th-th';
import * as Turkish from './tr-tr';
import * as Ukrainian from './ua-ua';
import * as Vietnamese from './vn-vn';
import * as Chinese from './zh-cn';
import * as TraditionalChinese from './zh-tw';

export {
    Arabic,
    Catalan,
    Czech,
    Danish,
    German,
    English,
    Spanish,
    Persian,
    Finnish,
    French,
    Hebrew,
    Hungarian,
    Italian,
    Japanese,
    Korean,
    Latvian,
    Dutch,
    Norwegian,
    Polish,
    Portuguese,
    Romanian,
    Russian,
    Slovak,
    Swedish,
    Thai,
    Turkish,
    Ukrainian,
    Vietnamese,
    Chinese,
    TraditionalChinese
}
